module.exports = __webpack_public_path__ + "images/icon-192.png";